import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const samplingEditSchema = z.object({
  name: z.string().nonempty('Name is required')
});

type SamplingEditFormValues = z.infer<typeof samplingEditSchema>;

export const useSamplingEditForm = (
  defaultValues?: Partial<SamplingEditFormValues>
) => {
  return useForm<SamplingEditFormValues>({
    resolver: zodResolver(samplingEditSchema),
    defaultValues: {
      name: '',
      ...defaultValues
    }
  });
};
